'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('workorder-ticket-list', {
      url: '/workorder/ticket/list',
      template: '<work-order-ticket-list></work-order-ticket-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/workorders/ticket-list/workorder-ticket-list.routes.js